// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;&#145;Peace be within your walls&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and tranquillity within your palaces.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;